import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Fa from 'react-fontawesome';
import { Link } from 'react-router-dom';
import masterField from '../../../../components/search-form/master-field';

class OpportunityOwner extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
    this.handleEnableClick = this.handleEnableClick.bind(this);
    this.handleDisableClick = this.handleDisableClick.bind(this);
  }

  handleEnableClick() {
    const { disabled } = this.props;
    if (!disabled) {
      this.props.onChange(true);
    }
  }
  
  handleDisableClick() {
    const { disabled } = this.props;
    if (!disabled) {
      this.props.onChange(false);
    }
  }

  renderStatic(lbl, disabled) {
    const { value, editable } = this.props;
    const stl = editable ? { cursor: disabled ? 'not-allowed' : 'pointer' } : {};
    const link = (
      <span>
        {' '}
        <Link to="/setup/feedback-requests/users">Manage users <Fa name="arrow-right" /></Link>
      </span>
    );
    const icon = editable ? (<span><Fa className={value ? 'text-active' : ''} name={value ? 'check-circle' : 'circle-o'} />{' '}</span>) : null;

    return (
      <div>
        <span style={stl} onClick={this.handleEnableClick}>
          {icon}
          <span className={value ? '' : 'text-muted'}>The {lbl} owner must be enabled/connected to TruSales.</span>
        </span>
        {value && link}
      </div>
    );
  }

  render() {
    const { disabled, value, editable, isAccount } = this.props;

    if (!editable) {
      return this.renderStatic(null, disabled);
    }
    const stl = { cursor: disabled ? 'not-allowed' : 'pointer' };
    const lbl = isAccount ? 'account/company' : 'opportunity/deal';
    return (
      <div>
        {this.renderStatic(lbl, disabled)}
        <div style={{ height: '10px' }} />
        <div>
          <span style={stl} onClick={this.handleDisableClick}>
            <Fa className={!value ? 'text-active' : ''} name={!value ? 'check-circle' : 'circle-o'} />
            {' '}
            <span className={!value ? '' : 'text-muted'}>The {lbl} owner does not need to be enabled/connected to TruSales.</span>
          </span>
        </div>
      </div>
    );
  }
}

OpportunityOwner.propTypes = {
  value: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  editable: PropTypes.bool,
  isAccount: PropTypes.bool,
};
OpportunityOwner.defaultProps = {
  disabled: false,
  editable: true,
  isAccount: false,
  onChange: () => {},
};
export default masterField(OpportunityOwner);
